












import { Component, Vue } from "vue-property-decorator";

var eventHub = new Vue();
Vue.prototype.toast = (txt: any) => {
  eventHub.$emit("toast", txt);
  setTimeout(() => {
    eventHub.$emit("hidetToast");
  }, 1500);
};

@Component
export default class Toast extends Vue {
  showErrorInfo = false;
  info = "";
  type = "";

  created() {
    eventHub.$on("toast", (txt: any) => {
      this.info = txt;
      this.showErrorInfo = true;
    });
    eventHub.$on("hidetToast", () => {
      this.info = "";
      this.showErrorInfo = false;
    });
  }
}
